import React, { useEffect, useState, useContext, useMemo, useRef } from 'react'
import Table2 from "../../../../templates/components/Table2"
import ProviderService from "../../../../../services/api/provider.service";
import moment from "moment";
import PracticeLocationSelector from '../../../../templates/components/PracticeLocationSelector';
import { store } from '../../../../../context/StateProvider';
import Module from '../../../../templates/components/Module';
import Utilities from '../../../../../services/commonservice/utilities';
import ModalBox from '../../../../templates/components/ModalBox';
import UnavailableBlockForm from '../../unavailable-block/unavailable-block-form/UnavailableBlockForm';
import toast from 'react-hot-toast';
import DatePicker from '../../../../templates/components/DatePicker';
import HPTSelect from '../../../../templates/components/HPTSelect';
import { useGetLocationProviderServices } from '../../../../../services/cache/CacheService';
import CacheUtilities from '../../../../../services/cache/CacheUtilities';
import APIResponse from '../../../../templates/components/APIResponse';

const UnavailableBlockTable = (props) => {
  const state = useContext(store).state
  const [isLoader, setIsLoader] = useState(false);
  const [isLoader_Provider, setIsLoader_Provider] = useState(false)
  const [unavailableBlockList, setUnavailableBlockList] = useState([]);
  const [startDate, setStartDate] = useState(moment().startOf("D"));
  const [endDate, setEndDate] = useState(moment().endOf("D"));
  const [selectedBlock, setSelectedBlock] = useState()
  const [show, setShow] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [doctorId, setDoctorId] = useState(props.providerId ? props.providerId : null)
  const [locationId, setLocationId] = useState(state.practiceLocationId || null)
  const [providerList, setProviderList] = useState()
  const stateDoctorList = useGetLocationProviderServices();
  const [apiResponse, setApiResponse] = useState()

  const firstRun = useRef(true);

  const onLocationChanged = (newLocationId) => {
    if (newLocationId !== null) {
      setDoctorId(null);
    }
    setLocationId(newLocationId);
  }

  const onSuccess = (message) => {
    setUnavailableBlockList([])
    getUnavailableBlocks();
  }

  const deleteBlock = (id) => {
    setIsLoader(true)
    return ProviderService.deleteUnavailableBlock(id)
      .then(response => {
        setApiResponse(response)
        getUnavailableBlocks();
      })
      .catch(err => {
        setApiResponse(err)
      })
      .finally(() => {
        setSelectedBlock(); 
        setIsLoader(false)
      });
  }

  const hiddenColumns = useMemo(() => {
    if (props.providerId) {
      return ['startTime', 'endTime', 'doctorId']
    }
    else {
      return ['startTime', 'endTime']
    }
  }, [props.providerId])

  const desktopHiddenColumns = useMemo(() => {
    if (props.providerId) {
      return ['doctorId']
    }
    else {
      return null
    }
  }, [props.providerId])

  useEffect(() => {
  if (firstRun.current) {
    firstRun.current = false;
    return;
  }
  getUnavailableBlocks();
}, [doctorId, locationId, startDate, endDate]);

  useEffect(() => {
    let isMounted = true;

    const loadProviders = async () => {
      try {
        setIsLoader_Provider(true);
        setProviderList(null); // Reset provider list before loading new data
        let providers;

        // If no location selected, load all providers
        if (!locationId) {
          providers = await CacheUtilities.pullServiceForLocationData(null);
        } else {
          // For specific location
          if (locationId === state.practiceLocationId) {
            providers = stateDoctorList;
          } else {
            providers = await CacheUtilities.pullServiceForLocationData(locationId);
          }
        }
        
        // Only update if component is still mounted and we have valid providers
        if (isMounted && providers && Array.isArray(providers)) {
          setProviderList(providers);
        }
      } catch (error) {
        console.error('Error loading providers:', error);
        if (isMounted) {
          setProviderList([]);
        }
      } finally {
        if (isMounted) {
          setIsLoader_Provider(false);
        }
      }
    };

    loadProviders();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [locationId, stateDoctorList]);

  

  const getUnavailableBlocks = () => {

    let fromDate = Utilities.toISOStringWithoutOffset(startDate)+'.000Z'
    let toDate = Utilities.toISOStringWithoutOffset(endDate)+'.000Z';

    let reqObj = {
      FromDate: fromDate,
      ToDate: toDate
    }

    if (locationId) {
      reqObj.PracticeLocationId = locationId
    }
    
    if(!doctorId && !locationId){
      //if both dont exist
      reqObj.WholePractice = true
    }
    if (doctorId) {
      reqObj.DoctorId = doctorId
    }
    ProviderService.getUnavailableBlock(reqObj).then(res => {
      if( res?.data?.selectResponse && res?.data?.selectResponse?.length > 0) {
        setUnavailableBlockList(res?.data?.selectResponse.sort((a, b) => new Date(a.startDate) - new Date(b.startDate)))
      }else{
        setUnavailableBlockList([])
      }
      
    }).catch(() => {
      toast.error('Oops! Something went wrong');
    });
  }

const timeToLocalDate = (time) => {
  // Fallback to midnight if invalid
  if (!time || typeof time !== "string" || !time.includes(":")) {
    return moment("1900-01-01T00:00:00.000");
  }
  let timeparts = time.split(":");
  return moment(`1900-01-01T${timeparts[0]}:${timeparts[1]}:00.000`);
};

  const columns = [
    {
      id: "description",
      Header: "Description",
      accessor: (block) => block.description || ""
    },
    {
      id: "startDate",
      Header: "From Date",
      accessor: (block) =>
        block.startDate
          ? moment(block.startDate).utc().format("MM/DD/YYYY")
          : "--",
    },
    {
      id: "startTime",
      Header: "Time",
      accessor: (block) =>
        block.startWholeDay == 1
          ? "All Day"
          : block.startTime
            ? moment(timeToLocalDate(block.startTime)).format("h:mm A")
            : "--",
    },
    {
      id: "endDate",
      Header: "To Date",
      accessor: (block) =>
        block.endDate
          ? moment(block.endDate).utc().format("MM/DD/YYYY")
          : "--",
    },
    {
      id: "endTime",
      Header: "Time",
      accessor: (block) =>
        block.endWholeDay == 1
          ? "All Day"
          : block.endTime
            ? moment(timeToLocalDate(block.endTime)).format("h:mm A")
            : "--",
    },
    {
      id: "doctorId",
      Header: "Provider",
      align: "left",
      sortable: true,
      accessor: (block) => {
        if (block.wholePractice === 1) {
          return "Whole Practice";
        }
        if (providerList && block.doctorId) {
          const selectedDoctor = providerList?.find((obj) => obj.id === block.doctorId);
          return selectedDoctor ? (selectedDoctor.firstName + ' ' + selectedDoctor.lastName) : "Provider Only";
        }
        if(!block.doctorId){
          return "All Provider";
        }
        return "Provider Only";
      },
    },
    {
      id: "actions",
      Header: "Actions",
      textAlign: "center",
      disableSortBy: true,
      accessor: (block) => {
        return (
          <div className="d-flex justify-content-center">
            <div className="btn-group">
              <button
                className="p-1 btn btn-primary"
                title="Edit Block"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedBlock(block);
                  return setShow(true);
                }}
              >
                <i className="icon pencil" />
              </button>
              <button
                className="p-1 btn btn-primary"
                title="Delete Block"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedBlock(block);
                  return setDeleteModal(true);
                }}
              >
                <i className="icon trash" />
              </button>
            </div>
          </div>
        );
      },
    },
  ];


  return (
    <div className="row d-flex g-3">
      <div className='col-12 px-0'>
        <Module title="Filters">
          <div className='row d-flex'>
            <div className='col-12 mx-0  report-filters'>
            <div className='d-flex row justify-content-center align-items-end'>
            <DatePicker startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate}/>
              <div className='col-md col-12'>
                <div className='ui field'>
                  <label>Practice Location</label>
                  <PracticeLocationSelector 
                    locationId={locationId} 
                    isClearable={true} 
                    placeholder={doctorId ? "All Practice Location" : "Whole Practice"} 
                    dontResetState={true} 
                    onSelected={onLocationChanged} 
                  />
                </div>
              </div>
              <div className='col-md col-12'>
                <label>Provider</label>
                <HPTSelect
                  className="react-select-container"
                  classNamePrefix="react-select"
                  options={providerList}
                  name="doctorId"
                  //isDisabled={!providerList}
                  isClearable={true}
                  isSearchable={true}
                  value={providerList && doctorId ? providerList.find(obj => obj.id === doctorId) : null}
                  onChange={e => {
                    if (e?.id) {
                      setDoctorId(e.id)
                    }
                    else {
                      setDoctorId()
                    }
                  }}
                  loadingMessage="Providers are loading..."
                  placeholder={"All"}
                  isLoading={isLoader_Provider}
                  getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                  getOptionValue={(option) => option.id}
                />
              </div>
            </div>
            </div>
          </div>
        </Module>
      </div>
      <div className='col-12 px-0'>
        <Module title="Closed/Away Times">
          <Table2
            hiddenColumns={hiddenColumns}
            export
            desktopHiddenColumns={desktopHiddenColumns}
            searchable
            loading={isLoader}
            columns={columns}
            data={unavailableBlockList}
            extraButtons={[
              {
                className: 'btn btn-primary',
                onClick: () => { setSelectedBlock(); return setShow(true) },
                children: <i className="icon add" title="Add Block" />
              },
            ]}

          />
        </Module>
      </div>
      <ModalBox
        open={show}
        onClose={() => setShow(false)}
        title={!selectedBlock ? "Add Time Block" : "Edit Time Block"}
      >
        {selectedBlock ? <UnavailableBlockForm
          unavailableBlockId={selectedBlock.unavailableBlockId}
          refresh={() => { getUnavailableBlocks() }}
          onClose={() => {
            setShow(false);
          }}
        /> : <UnavailableBlockForm
          providerId={props.providerId || null}
          refresh={() => { getUnavailableBlocks() }}
          onClose={() => {
            setShow(false);
          }}
        />}
      </ModalBox>
      <ModalBox open={deleteModal} onClose={() => { setDeleteModal(false) }} title="Delete Block">
        {selectedBlock?.unavailableBlockId && <div className='row d-flex align-items-center justify-content-between'>
          <div className='col-md-auto col-12'>
            Are you sure you want to delete {selectedBlock.description} ?
          </div>
          <div className='col-auto'>
            <button className='btn btn-secondary' onClick={e => { e.preventDefault(); setSelectedBlock(); return setDeleteModal(false) }}>No</button>
            <button className='btn btn-primary ms-3' onClick={e => { e.preventDefault(); deleteBlock(selectedBlock?.unavailableBlockId); setDeleteModal(false) }}>Yes</button>
          </div>
        </div>}
      </ModalBox>
      <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
    </div>
  );
};

export default UnavailableBlockTable;

